import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { Button, Image, Link } from "@components/core";
import { useInitializePlan, useTunnelSteps } from "@hooks/use-tunnel-steps";
import { useEffect } from "react";

function DrawerLead() {
  const t = useTranslations("common");

  const initializePlan = useInitializePlan();
  const { featuredPlan } = useTunnelSteps();

  const { planItemsCount, pantsCount, dressesCount } = useMemo(() => {
    const planItemsCount = featuredPlan?.clothes + featuredPlan?.accessories;
    const pantsCount = (planItemsCount / 2) + 1;
    const dressesCount = planItemsCount - pantsCount;

    return {
      planItemsCount,
      pantsCount,
      dressesCount,
    };
  }, [featuredPlan]);

  function initializeFeaturedPlan() {
    if (!featuredPlan?.id) {
      initializePlan();
    }
  }

  useEffect(() => {
    initializeFeaturedPlan();
  }, []);

  if (!featuredPlan?.id) return null;

  return [
    <div className="drawer-body bg-white p-4" key="drawer-lead-body">
      <div className="p-2 mb-4 text-center">
        <h5 className="mb-2">{t("drawer.modal_lead.title")}</h5>
        <p className="mb-0 text-gray">{t("drawer.modal_lead.subtitle")}</p>
      </div>
      <div style={{ width: "200px" }} className="mx-auto mb-4">
        <Image
          src="closetLight"
          alt={t("drawer.modal_lead.img_alt")}
          className="w-100"
        />
      </div>

      <div className="py-4 m-2">
        <div className="d-flex flex-column gap-4 mb-0">
          <div>
            <p className="mb-1 font-weight-bold">
              {t("drawer.modal_lead.fill_it.title", { count: planItemsCount })}
            </p>
            <p className="mb-0 text-gray">
              {t("drawer.modal_lead.fill_it.content", { count: dressesCount, pantsCount: pantsCount, topsCount: planItemsCount })}
            </p>
          </div>
          <div>
            <p className="mb-1 font-weight-bold">
              {t("drawer.modal_lead.wear_it.title")}
            </p>
            <p className="mb-0 text-gray">
              {t("drawer.modal_lead.wear_it.content")}
            </p>
          </div>
          <div>
            <p className="mb-1 font-weight-bold">
              {t("drawer.modal_lead.return_it.title")}
            </p>
            <p className="mb-0 text-gray">
              {t("drawer.modal_lead.return_it.content")}
            </p>
          </div>
        </div>
      </div>
    </div>,
    <div className="p-3 border-top bg-white" key="drawer-lead-footer">
      <Link href="/je-commence/ready-to-subscribe">
        <Button
          fullWidth
        >
          {t("drawer.modal_lead.get_started")}
        </Button>
      </Link>
    </div>,
  ];
}

export default DrawerLead;
